import { createSelector } from 'reselect';

import { ACG_ALL } from 'Lib/constant';
import { sortAcgAlphaNumeric } from 'Lib/stringHelpers';
import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';
import { getAccountClientGroups, getUsers } from 'Selectors/common';

const getIncludeAllAcg = (_state: AdminState, includeAllAcg: boolean, _includeDeleted: boolean) => includeAllAcg;
const getIncludeDeleted = (_state: AdminState, _includeAllAcg: boolean, includeDeleted: boolean) => includeDeleted;
const getAcgId = (_state: AdminState | ClientState, acgId: string) => acgId;

export const getAcgArray = createSelector(
    [ getAccountClientGroups, getIncludeAllAcg, getIncludeDeleted ],
    (accountClientGroups, includeAllAcg, includeDeleted) => {
        return Object.keys(accountClientGroups)
            .map(id => {
            //Change ACG Number to capitalized whenever receiving acgs
                if (accountClientGroups[id]) return {
                    ...accountClientGroups[id],
                    ACGNumber: accountClientGroups[id].ACGNumber.toUpperCase()
                };
            })
            .filter(acg => {
                if (includeAllAcg && includeDeleted) {
                    return acg;
                } else if (!includeAllAcg && includeDeleted) {
                    return acg && acg.ACGNumber !== ACG_ALL['number'];
                } else if (includeAllAcg && !includeDeleted) {
                    return acg && !acg.IsDeleted;
                } else if (!includeAllAcg && !includeDeleted) {
                    return acg && !acg.IsDeleted && acg.ACGNumber !== ACG_ALL['number'];
                }
            });
    }
);

export const getAcgSelectOptions = createSelector(getAcgArray, (AcgArray) => {
    return AcgArray
        .map(acg => {
            return {
                label: acg?.ACGNumber,
                value: acg?.ACGId
            };
        })
        .sort((a, b) => sortAcgAlphaNumeric(a.label, b.label));
});

export const getAcgById = createSelector(
    [ getAccountClientGroups, getAcgId ],
    (accountClientGroups, acgId) => accountClientGroups[acgId]
);

export const getAcgArrayWithModifiedByNames = createSelector(
    [ getAcgArray, getUsers ],
    (acgArray, users) => {
        return acgArray.map(acg => {
            if (acg?.ModifiedBy) {
                return {
                    ...acg,
                    ModifiedBy: users[acg.ModifiedBy] && `${users[acg.ModifiedBy].FirstName} ${users[acg.ModifiedBy].LastName}`
                };
            }

            return { ...acg };
        });
    }
);